module.exports = __webpack_public_path__ + "static/media/Share.0585347c.svg";